module.exports = __webpack_public_path__ + "d66f6f5ad1aafd4dec9779745d7e0268.svg";